import { BaseGridConfig, Flags, LayoutGridType, LayoutsState } from './models';
import _ from 'lodash';
import { createSelector } from '@reduxjs/toolkit';

export function filterOptions(
    state: LayoutsState,
    gridType: LayoutGridType
): BaseGridConfig['filterOptions'] {
    return state.selectedLayout[gridType].currentOptions.filterOptions;
}

export function columnOptions(
    state: LayoutsState,
    gridType: LayoutGridType
): BaseGridConfig['columnOptions'] {
    return state.selectedLayout[gridType].currentOptions.columnOptions;
}

export const rowGroupIds = createSelector(
    (state: LayoutsState, gridType: LayoutGridType) =>
        state.selectedLayout[gridType].currentOptions.rowGroups,
    (rowGroups) => rowGroups.filter((rg) => rg.checked).map((rg) => rg.colId)
);

export function rowGroupSorting(
    state: LayoutsState,
    gridType: LayoutGridType
): BaseGridConfig['rowGroupsSorting'] {
    return state.selectedLayout[gridType].currentOptions.rowGroupsSorting;
}

export function collapsedRowGroups(
    state: LayoutsState,
    gridType: LayoutGridType
): string[] {
    return state.selectedLayout[gridType].collapsedRowGroups;
}

export const selectedDatasetLayouts = createSelector(
    (state: LayoutsState) => state.allLayouts,
    (state: LayoutsState) => state.selectedDatasetId,
    (allLayouts, selectedDatasetId) => {
        const items = !selectedDatasetId
            ? allLayouts
            : allLayouts.filter(
                  (x) =>
                      !x.datasetId ||
                      x.datasetId < 1 ||
                      x.datasetId === selectedDatasetId
              );
        return _.orderBy(items, ['isTemplate', 'name'], ['asc', 'asc']);
    }
);

export function selectedDatasetTemplateLayouts(state: LayoutsState) {
    return selectedDatasetLayouts(state).filter((x) => x.isTemplate);
}

export function selectedDatasetUserLayouts(state: LayoutsState) {
    return selectedDatasetLayouts(state).filter((x) => !x.isTemplate);
}

function hasAtLeastOneFlag<T>(flags: Flags<T, boolean>): boolean {
    return Object.values(flags).some((x) => x === true);
}
export function hasPendingChanges(state: LayoutsState): boolean {
    const layout = state.selectedLayout;
    return (
        layout.areThereAnyUnsavedLayoutChanges ||
        hasAtLeastOneFlag(layout.fixtures.hasDifferencies) ||
        hasAtLeastOneFlag(layout.orders.hasDifferencies)
    );
}
